"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInfiniteScrollComponent = _interopRequireDefault(require("react-infinite-scroll-component"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _utils = require("../../utils");
var _Spin = _interopRequireDefault(require("../atoms/Spin"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  next: null,
  dataLength: 0,
  hasMore: false,
  children: null,
  endMessage: null,
  direction: 'column',
  className: ''
};
function InfiniteScroll(props) {
  const {
    next,
    dataLength,
    scrollableTarget,
    hasMore,
    children,
    endMessage,
    direction,
    className
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  return /*#__PURE__*/_react.default.createElement(StyledInfiniteScroll, {
    dataLength: dataLength,
    next: next,
    direction: direction,
    hasMore: hasMore,
    loader: /*#__PURE__*/_react.default.createElement(SpinWrapper, null, /*#__PURE__*/_react.default.createElement(_Spin.default, {
      center: true
    })),
    endMessage: endMessage,
    scrollableTarget: scrollableTarget,
    className: className
  }, children);
}
const StyledInfiniteScroll = (0, _styled.default)(_reactInfiniteScrollComponent.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), _ref => {
  let {
    direction,
    theme
  } = _ref;
  let styles = "\n      overflow-y: auto;\n    ";
  if (direction === 'row') {
    var _theme$colors;
    styles += "\n        overflow-y: hidden;\n        display: flex;\n        gap: 15px;\n        \n        &::-webkit-scrollbar {\n          height: 5px;\n        }\n\n        &::-webkit-scrollbar-track {\n          background: transparent;\n          border-radius: 5px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background:".concat((0, _utils.hexToRGBA)((_theme$colors = theme.colors) === null || _theme$colors === void 0 || (_theme$colors = _theme$colors.FONT) === null || _theme$colors === void 0 ? void 0 : _theme$colors.TITLE, 0.2), ";\n          border-radius: 5px;\n        }\n      ");
  }
  return styles;
});
const SpinWrapper = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 15px 0;\n"])));
var _default = exports.default = InfiniteScroll;